import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./index.css";
const App = React.lazy(() => import("./App"));
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n";

import { store } from "./employee/components/state/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { persistor } from "./employee/components/state/store";
import dicUtils from "@/utils/dicUtils";
import timeUtils from "@/utils/timeUtils";
import { message, Spin } from "antd";
import {CenteredSpinner} from "@/components/loading/CenteredSpinner";
import MessageModalProvider from "@/components/messageModal/MessageModalProvider";

const RootComponent = () => {

  let isHeadlesss = localStorage?.getItem('headlessDetected') === 'true'
  let isHeadless = (
    navigator.webdriver ||
    /HeadlessChrome/.test(navigator.userAgent)
  );

  if (isHeadless) {
    console.warn("🚨 Headless browser detected");
    isHeadlesss = true
    localStorage.setItem('headlessDetected', 'true');
  }

  if (isHeadlesss) {
    return (
      <div style={{ padding: 20, color: 'red', fontWeight: 'bold' }}>
        Access Denied: Browser detected.
      </div>
    );
  }

  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location = window.self.location;
    }
  }, []);

  const fetchData = async () => {
    try {
      try {
        await Promise.all([dicUtils.reload(), timeUtils.init()]);
      } catch (error) {

      }
    } catch (e) {
      message.error('Load dictionary error!');
      console.log('data dictionary loading error', e);
    }
  };
  useEffect(() => {
    fetchData();
    import("flag-icons/css/flag-icons.min.css");
    import("./App");
  }, []);

    return (
        <React.StrictMode>
            <BrowserRouter>
                <Provider store={store}>
                    <PersistGate loading={<CenteredSpinner />} persistor={persistor}>
                        <React.Suspense fallback={<CenteredSpinner />}>
                        <MessageModalProvider>
                            <App />
                        </MessageModalProvider>
                        </React.Suspense>
                    </PersistGate>
                </Provider>
            </BrowserRouter>
        </React.StrictMode>
    );
};

ReactDOM.render(<RootComponent />, document.getElementById("root"));